import React, { useState, useRef, useEffect } from "react";
import { Form, Row, Col, Image, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import Switch from "react-switch";
import { useFormik } from "formik";
import * as yup from "yup";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import moment from "moment";
import axios from "axios";
import { serverApi, videoUploadSize } from "../../../../../config/Keys";
import Alert from "react-s-alert";
import {
  addOfferAdminRestaurant,
  getCityFromCountry,
  getRestaurantByCityName,
} from "../../../../../store/actions/SuperAdminActions/adminManageOffers";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { getCountries } from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { NewSelectBoxInput } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ImageUpload } from "../../../../vendorDashboardComponents/offers/AddOfferScreen/AddOfferOnlineVendor";
import SimpleReactLightbox from "simple-react-lightbox";
import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";

const validationSchema = yup.object({
  // country: yup.string().required("Please select country"),
  // city: yup.string().required("Please select city"),
  // restaurant_id: yup.string().required("Please select Restaurant"),
  name: yup
    .string()
    .required("Offer name is required")
    .min(1, "Minimum 1 Character")
    .max(64, "Maximum 64 Character"),
  description: yup
    .string()
    .required("Description is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  start_date: yup.string().required("Start date is required"),
  start_time: yup.string().required("Start time is required"),
  end_date: yup.string().required("End date is required"),
  end_time: yup.string().required("End time is required"),
  coupon_code: yup
    .string()
    .required("Coupon code is required")
    .min(1, "Minimum 1 Character")
    .max(16, "Maximum 15 Character"),
  terms_and_condition: yup
    .string()
    .required("Terms and condtion  is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  photos: yup.array().min(1),
});

const OfflineOffer = (props) => {
  //state
  let history = useHistory();
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState();
  const [file, setFile] = useState(null);
  const [Video, setVideo] = useState(null);
  const toggleFunction = (e) => {
    setActive({ active: !active.active });
  };
  const [primaryOffer, setPrimaryOffer] = useState(false);
  const markAsPrimary = (e) => {
    setPrimaryOffer({ primaryOffer: !primaryOffer.primaryOffer });
  };

  /*************************************
   * @DESC Multiple Image Upload
   ************************************/
  const [combined, setCombined] = React.useState("");
  const [restaurant_pictures_new, setResPicNew] = React.useState([]);
  const onCompleteUploadMultipleCrop = (e, file) => {
    let oldData = formik.values.photos;
    let newData = e;
    let mergedData = oldData.concat(newData);
    formik.setFieldValue("photos", mergedData);
    cancelFiles(file);
  };

  const cancelFiles = (file) => {
    let restaurant_pictures_temp = restaurant_pictures_new;

    let newToUpload = restaurant_pictures_temp.filter((item, index) => {
      return item.name !== file.name;
    });
    setResPicNew(newToUpload);
  };

  const bankUploadMultipleFiles = (e) => {
    if (formik.values.photos.length + e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      var newUploaded = [];
      var docs = false;
      for (let i = 0; i < e.target.files.length; i++) {
        let allPicures = formik.values.photos;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          if (e.target.files[i].type === "application/pdf") {
            docs = true;
            data.append("files", e.target.files[i]);
          } else {
            newUploaded.push(e.target.files[i]);
          }
        }
      }
      if (!flag) {
        setResPicNew(newUploaded);
        setCombined(combined);
        if (docs) {
          axios
            .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
            .then((res) => {
              let oldData = formik.values.photos;
              let newData = res.data;
              let mergedData = oldData.concat(newData);
              formik.setFieldValue("photos", mergedData);
              Alert.success(`<h4>Image Upload Successfully</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            })
            .catch((err) => {
              Alert.error(`<h4>${err}</h4>`, {
                position: "top-right",
                effect: "bouncyflip",
                beep: true,
                html: true,
                timeout: 3000,
                offset: 35,
              });
            });
        }
      } else {
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
    e.target.value = "";
  };

  const bankDocMultipleRemove = (indexId) => {
    let allImages = formik.values.photos.filter((item, index) => {
      return index !== indexId;
    });
    formik.setFieldValue("photos", allImages);
  };

  // const uploadImage = (e) => {
  //   const data = new FormData();
  //   data.append("files", e.target.files[0]);
  //   //setFile(URL.createObjectURL(e.target.files[0]));

  //   axios
  //     .post(`${serverApi}/upload-assets?uploadSide=OfflineOffer`, data, {
  //       headers: {
  //         "content-type": "multipart/form-data",
  //       },
  //     })
  //     .then((res) => {
  //       setFile(res.data[0]);
  //       //formik.setFieldValue("photos", res.data[0]);
  //       formik.setFieldValue(`photos[0]`, res.data[0]);
  //     })
  //     .catch((err) => {
  //       Alert.error(`<h4>Error while uploading the image</h4>`, {
  //         position: "top-right",
  //         effect: "bouncyflip",
  //         beep: true,
  //         html: true,
  //         timeout: 3000,
  //         offset: 35,
  //       });
  //     });
  // };

  // const removeImage = () => {
  //   setFile(null);
  //   formik.setFieldValue("photos", []);
  // };

  const uploadVideo = (e) => {
    if (e.target.files) {
      if (e.target.files[0].size > videoUploadSize) {
        alert("File is too Big");
      } else {
        setLoading(true);
        const data = new FormData();
        data.append("file", e.target.files[0]);
        axios
          .post(`${serverApi}/upload-assets-video`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            setLoading(false);
            Alert.success(`<h4>Video uploaded sucessfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });

            setVideo(res.data);
            //formik.setFieldValue("photos", res.data[0]);
            formik.setFieldValue(`videos[0]`, res.data);
          })
          .catch((err) => {
            Alert.error(`<h4>Error while uploading the video</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    }
  };
  const removeVideo = () => {
    setVideo(null);
    formik.setFieldValue(`videos[0]`, "");
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const onSuccessAddOffer = () => {
    setLoading(false);
    history.push("/restaurantadminoffers");
  };

  const formik = useFormik({
    initialValues: {
      country: "",
      city: "",
      restaurant_id: "",
      vendor_id: "",
      vendor_ID: "",
      name: "",
      description: "",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      coupon_code: "",
      photos: [],
      videos: [],
      terms_and_condition: "",
      isOnline: false,
      isGlobal: false,
      pointOfEntry: "SUPERADMIN",
    },
    validationSchema,

    onSubmit: (values) => {
      if (values.vendor_id !== "" || values.vendor_ID !== "") {
        var formData = {};
        const startDate = {
          start_date: moment(
            values.start_date + "T" + values.start_time
          ).toISOString(),
        };
        const end_Date = {
          end_date: moment(
            values.end_date + "T" + values.end_time
          ).toISOString(),
        };

        // var location = {
        //   latitude: "26.23568784466822",
        //   longitude: "78.15339087385253",
        // };

        formData.name = values.name;
        formData.description = values.description;
        formData.coupon_code = values.coupon_code;
        formData.start_date = startDate.start_date;
        formData.end_date = end_Date.end_date;
        formData.photos = values.photos;
        formData.videos = values.videos;
        formData.terms_and_condition = values.terms_and_condition;
        formData.active = active.active;
        formData.mark_as_primary = primaryOffer.primaryOffer;
        formData.send_to_carousel = false;
        formData.isOnline = values.isOnline;
        formData.isGlobal = values.isGlobal;
        formData.restaurant_id = values.restaurant_id;
        formData.vendor_id =
          values.vendor_ID === "" ? values.vendor_id : values.vendor_ID;
        formData.location = values.location;

        // formData.restaurant_id = "5f8abd6bc0aac52d42af609c";
        // formData.vendor_id = "5f8abd62c0aac52d42af609b";
        // formData.location = location;

        const onErrorAddOffer = () => {
          setLoading(false);
        };
        const token = props.auth.user.accessToken;
        setLoading(true);
        props.addOfferAdminRestaurant(
          token,
          formData,
          onSuccessAddOffer,
          onErrorAddOffer
        );
      } else {
        Alert.error(`<h4>Select Restaurant Or Enter Vendor Id</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    formik.setFieldValue("name", "");
  }, []);
  // for set focus
  useEffect(() => {
    // if (formik.errors && formik.errors.country) {
    //   let countrytElement = document.getElementById(
    //     "demo-simple-select-outlined"
    //   );
    //   countrytElement.focus();
    // } else if (formik.errors && formik.errors.city) {
    //   let cityElement = document.getElementById("city");
    //   cityElement.focus();
    // } else if (formik.errors && formik.errors.restaurant_id) {
    //   let restElement = document.getElementById("restaurant_id");
    //   restElement.focus();
    // }
    if (formik.errors && formik.errors.name) {
      let nameElement = document.getElementById("name");
      nameElement.focus();
    } else if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik.errors && formik.errors.start_date) {
      let startDateElement = document.getElementById("start_date");
      startDateElement.focus();
    } else if (formik.errors && formik.errors.start_time) {
      let startTimeElement = document.getElementById("start_time");
      startTimeElement.focus();
    } else if (formik.errors && formik.errors.end_date) {
      let endDateElement = document.getElementById("end_date");
      endDateElement.focus();
    } else if (formik.errors && formik.errors.end_time) {
      let endTimeElement = document.getElementById("end_time");
      endTimeElement.focus();
    } else if (formik.errors && formik.errors.coupon_code) {
      let couponCodeElement = document.getElementById("coupon_code");
      couponCodeElement.focus();
    } else if (formik.errors && formik.errors.terms_and_condition) {
      let termAndCondtionsElement = document.getElementById(
        "terms_and_condition"
      );
      termAndCondtionsElement.focus();
    }
  }, [count]);

  const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: "100%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));
  const classes = useStyles();
  const [state, setState] = useState({
    country: "",
    restaurant: "",
    state: "",
    city: "",
  });
  const [city, setCity] = useState([]);

  const onSuccessGetCity = (data) => {
    var prepareCity = [];
    for (var i = 0; i < data.length; i++) {
      prepareCity.push({ label: data[i], value: data[i] });
    }
    setCity(prepareCity);
  };
  const onErrorGetCity = () => {};
  const selecthandleChange = (e) => {
    formik.setFieldValue("vendor_ID", "");
    const token = props.auth.user.accessToken;
    props.getCityFromCountry(
      e.target.value,
      token,
      onSuccessGetCity,
      onErrorGetCity
    );
    setState({ [e.target.name]: e.target.value });
    formik.setFieldValue("country", e.target.value);
    formik.setFieldValue("city", "");
    formik.setFieldValue("restaurant_id", "");
    setRestaurant([]);
    setCity([]);
  };

  const [restaurant, setRestaurant] = useState([]);

  const onSuccessGetRestaurant = (data) => {
    formik.setFieldValue("vendor_ID", "");
    var prepareRestaurant = [];
    for (var i = 0; i < data.length; i++) {
      prepareRestaurant.push(data[i]);
    }
    setRestaurant(prepareRestaurant);
  };
  const onErrorGetRestaurant = () => {};

  const loadRestaurant = (event) => {
    formik.setFieldValue("vendor_ID", "");
    setState({
      ...state,
      city: event.target.value,
    });

    formik.setFieldValue("city", event.target.value);
    formik.setFieldValue("restaurant_id", "");

    const token = props.auth.user.accessToken;
    props.getRestaurantByCityName(
      state.country,
      event.target.value,
      token,
      onSuccessGetRestaurant,
      onErrorGetRestaurant
    );
  };

  const onChangeRestaurant = (event) => {
    formik.setFieldValue("vendor_ID", "");
    setState({
      ...state,
      restaurant: event.target.value,
    });
    for (var i = 0; i < restaurant.length; i++) {
      if (restaurant[i]._id === event.target.value) {
        formik.setFieldValue("restaurant_id", restaurant[i]._id);
        formik.setFieldValue("vendor_id", restaurant[i].vendor_id);
        formik.setFieldValue("location", restaurant[i].location);
      }
    }
  };

  const vendorIdChangeHandler = (e) => {
    setState({
      ...state,
      country: "",
      city: "",
      restaurant: "",
    });
    formik.setFieldValue("vendor_ID", e.target.value);
  };

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");
  const handleStartDateChange = (e) => {
    formik.setFieldValue("start_date", e.target.value);
    formik.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };

  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  return (
    <React.Fragment>
      {!loading ? <></> : <AmealioLoader />}
      <Form>
        <Row>
          <Col lg={3}>
            <Form.Group>
              <NewSelectBoxInput
                selectLabel="Country"
                name="country"
                value={state.country}
                onChange={selecthandleChange}
                getCountries={getCountries}
                en={en}
              />

              {formik.errors.country && formik.touched.country ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.country}
                </div>
              ) : null}
            </Form.Group>
          </Col>
          <Col lg={3}>
            <Row>
              {/* <Col md={6}>
                <Form.Group>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-State">State</InputLabel>
                    <Select
                      value={state.state}
                      onChange={selecthandleChange}
                      label="State"
                      inputProps={{
                        name: "state",
                        id: "outlined-State",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value={"State"}>State</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col> */}
              <Col md={12}>
                <Form.Group>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-City">City</InputLabel>
                    <Select
                      id="city"
                      value={state.city}
                      onChange={loadRestaurant}
                      label="City"
                      inputProps={{
                        name: "city",
                        id: "outlined-City",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {/* <option value={"City"}>City</option> */}

                      {city.map((item, index) => (
                        <MenuItem
                          label={item.label}
                          value={item.value}
                          key={index}
                        >
                          {item.value}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.errors.city && formik.touched.city ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.city}
                      </div>
                    ) : null}
                  </FormControl>
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col lg={3}>
            <Form.Group>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-Select Restaurant">
                  Select Restaurant
                </InputLabel>
                <Select
                  id="restaurant_id"
                  value={state.restaurant}
                  onChange={onChangeRestaurant}
                  label="Select Restaurant"
                  inputProps={{
                    name: "restaurant",
                    id: "outlined-restaurant",
                  }}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  {/* <MenuItem value={state.restaurant}></MenuItem> */}
                  {restaurant.map((item, index) => (
                    <MenuItem
                      label={item.restaurant_name}
                      value={item._id}
                      key={index}
                    >
                      {item.restaurant_name}
                    </MenuItem>
                  ))}
                </Select>
                {formik.errors.restaurant_id && formik.touched.restaurant_id ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.restaurant_id}
                  </div>
                ) : null}
              </FormControl>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <h5 className="col-12 f16-700 pl-5 pb-3">Or</h5>
          <div className="col-3">
            <Form.Group>
              <NewInputText
                extraClass="mb-1"
                name="vendor_ID"
                maxLength={35}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onInput={maxLengthCheck}
                inputType="number"
                onKeyDown={InputNumberFunc}
                onFocusOut={formik.handleBlur}
                // onChange={formik.handleChange}
                onChange={(e) => vendorIdChangeHandler(e)}
                value={formik.values.vendor_ID}
                labelText="Vendor ID"
                controlClass="vendor_ID"
              />
              {/* {formik2.errors.maxGuest_RSVP &&
                          formik2.touched.maxGuest_RSVP ? (
                            <div className="pho_14_regular text-danger">
                              {formik2.errors.maxGuest_RSVP}
                            </div>
                          ) : null} */}
            </Form.Group>
          </div>
        </Row>
        <Row className="pt-4">
          <Col lg={8}>
            <Form.Group>
              <TextField
                // ref={nameee}
                id="name"
                label="Offer Name"
                type="text"
                variant="outlined"
                className={`w-100 ${
                  formik.errors.name && formik.touched.name ? "enError" : ""
                }`}
                name="name"
                onChange={formik.handleChange}
                value={formik.values.name}
                onBlur={formik.handleBlur}
                isInvalid={formik.errors.name && formik.touched.name}
              />
              {formik.errors.name && formik.touched.name ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.name}
                </div>
              ) : null}
            </Form.Group>
            <Form.Group>
              <TextField
                // ref={description}
                id="description"
                label="Description"
                type="text"
                multiline
                rows="5"
                variant="outlined"
                className={`w-100 ${
                  formik.errors.description && formik.touched.description
                    ? "enError"
                    : ""
                }`}
                name="description"
                onChange={formik.handleChange}
                value={formik.values.description}
                onBlur={formik.handleBlur}
                //onInvalid={formik.errors.email && formik.touched.email}
                isInvalid={
                  formik.errors.description && formik.touched.description
                }
              />
              {formik.errors.description && formik.touched.description ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.description}
                </div>
              ) : null}
            </Form.Group>
            <Row className="pb-4">
              <Col lg={6}>
                <div className="f12-400">
                  (Fill out the details , offers are used offline)
                </div>
              </Col>
              <Col lg={6}>
                <div className="d-flex align-items-start">
                  <Switch
                    onChange={markAsPrimary}
                    checked={primaryOffer.primaryOffer}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                  />
                  <div className="pl-2">
                    <div className="f12-500 mb-2">Make this Offer Primary</div>
                    <div className="f10-400">
                      (Note you can make only one Offer primary, by making this
                      offer primary it will remove primary from other active
                      offers)
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={12}>
            <hr />
            <div className="font_20_b py-4">Offer Detailss</div>
            <Row className="pb-4 align-items-center">
              <Col md={3} xl={2}>
                <TextField
                  id="start_date"
                  label="Start Date"
                  variant="outlined"
                  InputProps={{
                    inputProps: { min: minDate },
                  }}
                  type="date"
                  defaultValue={minDate}
                  className={`w-100 ${
                    formik.errors.start_date && formik.touched.start_date
                      ? "enError"
                      : ""
                  }`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="start_date"
                  onChange={(e) => handleStartDateChange(e)}
                  //onChange={formik.handleChange}
                  value={formik.values.start_date}
                  onBlur={formik.handleBlur}
                  //onInvalid={formik.errors.email && formik.touched.email}
                  isInvalid={
                    formik.errors.start_date && formik.touched.start_date
                  }
                />
                {formik.errors.start_date && formik.touched.start_date ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.start_date}
                  </div>
                ) : null}
              </Col>
              <Col md={3} xl={2}>
                <TextField
                  id="start_time"
                  label="Start Time"
                  variant="outlined"
                  type="time"
                  className={`w-100 ${
                    formik.errors.start_time && formik.touched.start_time
                      ? "enError"
                      : ""
                  }`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="start_time"
                  onChange={formik.handleChange}
                  value={formik.values.start_time}
                  onBlur={formik.handleBlur}
                  isInvalid={
                    formik.errors.start_time && formik.touched.start_time
                  }
                />
                {formik.errors.start_time && formik.touched.start_time ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.start_time}
                  </div>
                ) : null}
              </Col>
              <Col md={3} xl={2}>
                <TextField
                  id="end_date"
                  label="End Date"
                  variant="outlined"
                  InputProps={{
                    inputProps: { min: minEndDate },
                  }}
                  type="date"
                  className={`w-100 ${
                    formik.errors.end_date && formik.touched.end_date
                      ? "enError"
                      : ""
                  }`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="end_date"
                  onChange={formik.handleChange}
                  value={formik.values.end_date}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.errors.end_date && formik.touched.end_date}
                />
                {formik.errors.end_date && formik.touched.end_date ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.end_date}
                  </div>
                ) : null}
              </Col>
              <Col md={3} xl={2}>
                <TextField
                  id="end_time"
                  label="End Time"
                  variant="outlined"
                  type="time"
                  className={`w-100 ${
                    formik.errors.end_time && formik.touched.end_time
                      ? "enError"
                      : ""
                  }`}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  name="end_time"
                  onChange={formik.handleChange}
                  value={formik.values.end_time}
                  onBlur={formik.handleBlur}
                  isInvalid={formik.errors.end_time && formik.touched.end_time}
                />
                {formik.errors.end_time && formik.touched.end_time ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.end_time}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="pb-4 align-items-center">
              <Col md={4} lg={4}>
                <Form.Group>
                  <TextField
                    id="coupon_code"
                    label="Coupon Code"
                    type="text"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.coupon_code && formik.touched.coupon_code
                        ? "enError"
                        : ""
                    }`}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="coupon_code"
                    onChange={formik.handleChange}
                    value={formik.values.coupon_code}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.errors.coupon_code && formik.touched.coupon_code
                    }
                  />
                  {formik.errors.coupon_code && formik.touched.coupon_code ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.coupon_code}
                    </div>
                  ) : null}
                </Form.Group>
              </Col>
              <Col md={4} lg={4}>
                {/* <Form.Group>
                  <TextField
                    label="Maximum Usage Limit"
                    type="text"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group> */}
              </Col>
              <Col md={4} lg={4}>
                <div className="form-group d-flex align-items-center">
                  <div className="f18-500 mr-2">Status</div>
                  <div className="f12-400 mr-2">
                    {active.active ? "Active" : "Inactive"}
                  </div>
                  <Switch
                    onChange={toggleFunction}
                    checked={active.active}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                  />
                </div>
              </Col>
            </Row>
            <hr />
            <Form.Group className="py-4">
              <div className="event-offer-image">
                <SimpleReactLightbox>
                  <MultipleImageUploadComponent
                    title="Upload Images"
                    smallTitle="(You can upload maximum 6 pic per event 700 x 420 pixels)"
                    onChange={bankUploadMultipleFiles}
                    //stateValue={bank_informaion}
                    stateValue={formik.values.photos}
                    newUploaded={
                      restaurant_pictures_new ? restaurant_pictures_new : []
                    }
                    combined={combined}
                    cancelFiles={cancelFiles}
                    onCompleteUploadMultipleCrop={onCompleteUploadMultipleCrop}
                    removeImage={bankDocMultipleRemove}
                    accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                    // loader={state.bankImageLoader}
                  />
                </SimpleReactLightbox>
              </div>
              {formik.errors.photos && formik.touched.photos ? (
                <div className="mb-3 pho_14_regular text-danger">
                  {formik.errors.photos}
                </div>
              ) : (
                <div className="mb-3"> </div>
              )}
              {/* <ImageUpload /> */}
              {/* <Form.Label className="f14-500 mb-3">Add Photos</Form.Label>
              <div className="d-flex flex-wrap">
                <div className="enUploadBox">
                  <Image
                    src={require("../../../../../assets/images/UserManagement/uploadImg.svg")}
                    alt="uploadImg"
                    title="uploadImg"
                    fluid
                  />
                  <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={(e) => uploadImage(e)}
                  />
                </div>
                {file && (
                  <div className="enIconUploaded">
                    <button
                      type="button"
                      className="enCloseButton"
                      onClick={() => removeImage()}
                    >
                      <Image
                        src={require("../../../../../assets/images/UserManagement/en_close.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                    </button>
                    <Image
                      src={file}
                      alt="icon"
                      title="icon"
                      className=""
                      fluid
                    />
                  </div>
                )}
              </div>
              <div className="pt-2 f12-400">
                (You can upload only 1 pic per offer 700 x 420 pixels)
              </div> */}
            </Form.Group>
            <Form.Group className="pb-4">
              <Form.Label className="f14-500 mb-3">Add Video</Form.Label>
              <div className="d-flex flex-wrap">
                <div className="enUploadBox">
                  <Image
                    src={require("../../../../../assets/images/UserManagement/uploadImg.svg")}
                    alt="Upload video"
                    title="Upload video"
                    fluid
                  />
                  <input type="file" accept=".mp4" onChange={uploadVideo} />
                </div>
                {Video && (
                  <div className="enIconUploaded">
                    <button
                      type="button"
                      className="enCloseButton"
                      onClick={() => removeVideo()}
                    >
                      <Image
                        src={require("../../../../../assets/images/UserManagement/en_close.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                    </button>
                    <video
                      width="100%"
                      height="100%"
                      controls
                      src={Video}
                      type="video/mp4"
                    />
                  </div>
                )}
              </div>
              <div className="pt-2 f12-400">
                (You can upload only 1 video per offer 700 x 420 pixels)
              </div>
            </Form.Group>
            <Row>
              <Col lg={8}>
                <Form.Group>
                  <TextField
                    id="terms_and_condition"
                    label="Terms and Conditions"
                    type="text"
                    multiline
                    rows="5"
                    variant="outlined"
                    className={`w-100 ${
                      formik.errors.terms_and_condition &&
                      formik.touched.terms_and_condition
                        ? "enError"
                        : ""
                    }`}
                    name="terms_and_condition"
                    onChange={formik.handleChange}
                    value={formik.values.terms_and_condition}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.errors.terms_and_condition &&
                      formik.touched.terms_and_condition
                    }
                  />
                  {formik.errors.terms_and_condition &&
                  formik.touched.terms_and_condition ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.terms_and_condition}
                    </div>
                  ) : null}
                </Form.Group>
                <div className="py-2 f12-400">
                  (Fill out the terms and conditions for offers are used
                  offline)
                </div>
              </Col>
            </Row>
            <div className="py-4 d-flex align-items-center">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5 btn150px"
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5 btn150px"
                //type="submit"
                onClick={() => onClickSave()}
              >
                Save
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

OfflineOffer.propTypes = {
  auth: PropTypes.object.isRequired,
  addOfferAdminRestaurant: PropTypes.func.isRequired,
  getCityFromCountry: PropTypes.func.isRequired,
  getRestaurantByCityName: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  addOfferAdminRestaurant,
  getCityFromCountry,
  getRestaurantByCityName,
})(OfflineOffer);
